import { spawn } from 'redux-saga/effects';

import autoSigninWatchers from './autoSignin';
import { watchSignOut } from './signOut';

export default function* saga() {
  yield spawn(autoSigninWatchers);
  yield spawn(watchSignOut);
}
